import { CouponsContent } from "./couponsContent";
import { CouponAndModalFormsProvider } from "./couponAndModalFormsContext";
import { GoalsProvider } from "../goals/goalsContext";

export function Coupons() {
  return(
      <CouponAndModalFormsProvider>
        <GoalsProvider>
           <CouponsContent />
        </GoalsProvider>
      </CouponAndModalFormsProvider>
  )
}

